module.exports = __webpack_public_path__ + "components/page-footer/static/surf-forecast__logo--white-4904dd8d80b0c0bbfa6cf831f45918dc.png";